@if (form) {
    <form [formGroup]="form" fxLayout="column" fxLayoutAlign="center center" class="pr-56 pl-56 pb-48 pt-48 w-100">
        <div class="h3-semi-bold c-primary-gray-900 text-center"> {{ 'i18n_af_trendGenerationDialogTitle' | translate }}</div>
        @if (!isTrendGenerationStarted) {
            <div class="mt-16 t2 c-primary-gray-900 pre-wrap text-center">
                {{ 'i18n_af_trendGenerationDialogSubtitle' | translate }}
            </div>

            <div class="mt-24 w-100">
                <af-date-range-picker-field [form]="form.controls.periodRange"
                    startTime="00:00"
                    endTime="23:59"
                    label="i18n_af_labelRange"
                    [maxDate]="maxDate"
                    [hasTime]="false"
                    [hasPickerActions]="false"
                    [startDate]="currentPeriodStartDate"
                    [endDate]="currentPeriodEndDate"
                />
            </div>
            <div class="mt-24 w-100">
                <af-dictionary-selector dictionaryName="trend_type"
                    [control]="form.controls.trendType"
                    label="i18n_af_labelTrendType"
                    placeholder="i18n_af_placeholderSelectTrendType"/>
            </div>
            <div class="mt-24 w-100">
                <af-dictionary-selector dictionaryName="incident_type"
                    [control]="form.controls.incidentType"
                    label="i18n_af_labelFraudType"
                    placeholder="i18n_af_placeholderFraudType"/>
            </div>
            <div class="mt-24 w-100">
                <af-dictionary-selector dictionaryName="fraud_type"
                    [control]="form.controls.fraudType"
                    label="i18n_af_fraudTypesTab"
                    placeholder="i18n_af_placeholderSelectFraudType"/>
            </div>

        } @else {
            <div class="mt-16 t2 c-primary-gray-900 pre-wrap text-center" fxFlexAlign="start">
                {{ 'i18n_af_trendGenerationDialogRunningSubtitle' | translate }}
            </div>
        }

        @if (Spinner.isShown('trendGenerationLoading')) {
            <div fxLayout="column" fxLayoutAlign="center center" class="mt-24 mb-24 w-100 h-100">
                <ui-kit-spinner spinnerIds="trendGenerationLoading"/>
            </div>
        }
        <ui-kit-button
            fxHide [fxShow]="!isTrendGenerationStarted"
            class="mt-32"
            [disabled]="form.invalid"
            (clickListener)="submitTrendGeneration()"
            [label]="'i18n_af_buttonRun' | translate"/>
        <ui-kit-button
            class="mt-12"
            type="text"
            (clickListener)="dialogRef.close()"
            [label]="'i18n_af_buttonCancel' | translate"/>
    </form>
}
